import config from "../../config";

export class StorageStore {
    private driver: Storage;
    private readonly key: string;

    public constructor(driver: Storage) {
        this.driver = driver;
        this.key = config.storage.key;
    }

    public getItem<T = string>(key: string, parsed = false): T | null {
        const data = this.driver.getItem(`${this.key}_${key}`);

        if (data && parsed) {
            return JSON.parse(data);
        }

        return data as any;
    }

    public setItem(key: string, data: any): StorageStore {
        this.driver.setItem(`${this.key}_${key}`, JSON.stringify(data));

        return this;
    }

    public removeItem(...keys: string[]): void {
        keys.forEach((key) => {
            this.driver.removeItem(`${this.key}_${key}`);
        });
    }

    public static sessionOrLocal(key: string): StorageStore | undefined {
        if (localStorage.getItem(`${config.storage.key}_${key}`)) {
            return new StorageStore(localStorage);
        }

        if (sessionStorage.getItem(`${config.storage.key}_${key}`)) {
            return new StorageStore(sessionStorage);
        }

        return undefined;
    }
}
